// Models
/** iCalendar dialog type */ export var ICalendarDialogType = /*#__PURE__*/ function(ICalendarDialogType) {
    ICalendarDialogType[ICalendarDialogType["Plan"] = 0] = "Plan";
    ICalendarDialogType[ICalendarDialogType["AssignedToMe"] = 1] = "AssignedToMe";
    return ICalendarDialogType;
}({});
/**
 * Defines different status ICalendarPublish when updating usersettings or plandetails
 */ export var IUpdateEntityStatusForICalendar = /*#__PURE__*/ function(IUpdateEntityStatusForICalendar) {
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["PublishSucceeded"] = 0] = "PublishSucceeded";
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["UnpublishSucceeded"] = 1] = "UnpublishSucceeded";
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["PublishFailed"] = 2] = "PublishFailed";
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["UnpublishFailed"] = 3] = "UnpublishFailed";
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["PublishingTasks"] = 4] = "PublishingTasks";
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["UnpublishingTasks"] = 5] = "UnpublishingTasks";
    IUpdateEntityStatusForICalendar[IUpdateEntityStatusForICalendar["None"] = 6] = "None";
    return IUpdateEntityStatusForICalendar;
}({});
